import { render, staticRenderFns } from "./MenuMobileView.vue?vue&type=template&id=3acf9b52"
import script from "./MenuMobileView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuMobileView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MenuMobileView.vue?vue&type=style&index=0&id=3acf9b52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports